<template>
  <div>
      <Header title="教学评价" type="0" route="/student/evaluate" ></Header>
      <NOdata v-if="this.evaluateList.length == 0" :title="warning"></NOdata>
      <div v-else :class="schoolCode == '14507' ? 'eva-body_14507' : 'eva-body'">
        <div class="grey-contain" v-for="(item,index) in evaluateList" :key="index">
          <div style="width:65%;">
            <h4 class="contain-txt">{{item.courseName}}</h4>
            <p class="contain-txt1">课程编号：{{item.courseNumber}}</p>
            <div class="contain-txt1">授课教师：<span style="color: #F86969;">{{item.teacherName}}</span></div>
          </div>
          <div class="history" v-if="item.isSubmitCode == 1" @click="goCheck(item.evaluationCategoriesId,item.courseId,item.teacherId,item.noticeId,item.schoolClassificationId,item.courseName,item.courseNumber,item.teacherName)">
            <h1>{{item.overallScore}}</h1>
            <p>总评分</p>
          </div>
          <button @click="goEvaluate(item.evaluationCategoriesId,item.courseId,item.teacherId,item.noticeId,item.schoolClassificationId,item.pjfs)" v-else>评价</button>
        </div>
      </div>
      <div class="history-btn">
        <button @click="checkHis()" v-if="viewBut">查看我的评价记录</button>
        <button @click="open()" v-if="schoolCode == '14507'">教师满意度评价</button>
        <button @click="dosubmit()" v-if="schoolCode == '14507'">提交</button>
      </div>
      
      <van-popup v-model="jsmydshow" position="bottom" @close="close">
        <div class="apply-pop">
          <div class="pop-title">
            <i class="close-icon" @click="close"></i>
            <p>你最喜欢的{{zdxzls}}位老师是</p>
            <i class="confirm-icon" @click="resetCancel()"></i>
          </div>
          <div class="person">
            <button
              :class="item.isBtn == 1 ? 'cur' : 'per-btn' "
              ref="person"
              v-for="(item, index) in pjlsList"
              @click="personTap($event, index)"
              :key="item.id"
            >
              {{ item.name }}
            </button>
          </div>
        </div>
      </van-popup>
  </div>
</template>

<script>
  import { Dialog } from "vant";
  import {Api} from '../../../utils/axios'
  export default {
    data(){
      return{
        schoolCode : sessionStorage.getItem("schoolCode"),
        viewBut:true,
        evaluateList:[],
        warning:'',
        jsmydshow:false,
        pjlsList:[],
        zdxzls:'',
        reset:'',
        resetId:'',
        xzjsList:[],
        tjs:'',
        zpjs:'',
        sfxzmydpj:''
      }
    },
    methods:{
      goCheck(id1,id2,id3,id4,id5,info1,info2,info3){
        this.$router.push({
          path:'/student/evaluateHistory',
          query:{
            'id0':this.$route.query.pj0502id,
            'id1':id1,
            'id2':id2,
            'id3':id3,
            'id4':id4,
            'id5':id5,
            'info1':info1,
            'info2':info2,
            'info3':info3
          }
        })
      },
      goEvaluate(id1,id2,id3,id4,id5,pjfs){
        // this.$router.push({
        //   path:'/student/detailEvaluate',
        //   query:{
        //     'id0':this.$route.query.pj0502id,
        //     'id1':id1,
        //     'id2':id2,
        //     'id3':id3,
        //     'id4':id4,
        //     'id5':id5
        //   }
        // })
          if(pjfs=="1"){
              this.$router.push({
                  path:'/student/detailEvaluatefs',
                  query:{
                      'id0':this.$route.query.pj0502id,
                      'id1':id1,
                      'id2':id2,
                      'id3':id3,
                      'id4':id4,
                      'id5':id5,
                      'pj01id':this.$route.query.pj01id,
                      'pj05id':this.$route.query.pj05id,
                      'pj0502id':this.$route.query.pj0502id,
                      'xnxq01id':this.$route.query.xnxq01id,
                      'pj02id':this.$route.query.pj02id
                  }
              })
          }
          else{
              this.$router.push({
                  path:'/student/detailEvaluate',
                  query:{
                      'id0':this.$route.query.pj0502id,
                      'id1':id1,
                      'id2':id2,
                      'id3':id3,
                      'id4':id4,
                      'id5':id5,
                      'pj01id':this.$route.query.pj01id,
                      'pj05id':this.$route.query.pj05id,
                      'pj0502id':this.$route.query.pj0502id,
                      'xnxq01id':this.$route.query.xnxq01id,
                      'pj02id':this.$route.query.pj02id
                  }
              })
          }
      },
      checkHis(){
        this.$router.push({
          path:'/student/teachEva',
          query:{
            'pj01id':this.$route.query.pj01id,
            'pj0502id':this.$route.query.pj0502id,
            'pj05id':this.$route.query.pj05id,
          }
        })
      },
      async getEvaluation(){
        const params = {
          'pj01id': this.$route.query.pj01id,
          'batchId': this.$route.query.pj0502id,
          'pj05id': this.$route.query.pj05id,
          'issubmit':'0'
        }
        const res = await Api.getTeachEvaluation(params)
        if(res.code == 0){
          this.viewBut = false;
        }else{
          this.viewBut = true;
        }
        if(this.schoolCode == '14507' ){
          this.tjs = res.tjs
          this.zpjs = res.zpjs
          this.sfxzmydpj = res.sfxzmydpj
          if(res.sfxzmydpj == 1){
            const pjParam = {
              xnxq01id:this.$route.query.xnxq01id,
              pj0502id:this.$route.query.pj0502id
            }
            const res = await Api.xspjJsmydpj(pjParam)
            if(res.code == '200'){
              let zxhlsid = res.zxhlsid;
              let concatList2 = [];
              res.skjslst.forEach((item, index) => {
                concatList2[index] = {
                  name: item.xm,
                  id: item.jg0101id,
                  isBtn: zxhlsid.includes(item.jg0101id) ? 1 : 0
                };
              });
              this.pjlsList = concatList2
              console.log(this.pjlsList)
              this.zdxzls = res.zdxzls
              this.jsmydshow = true;
            }
          }
        }
        this.evaluateList = res.data
        if(res.stateTime == '0'){
          this.warning = '暂无评价数据'
        }else if(res.stateTime == '1'){
          this.warning = '评价已完成'
        }
      },
      // 审核人弹框中的按钮选择
      personTap(e, res) {
        let strList = [];
        let idList = [];
        if (this.pjlsList[res].isBtn == 0) {
          this.pjlsList[res].isBtn = 1;
          e.target.className = "cur";
        } else if (this.pjlsList[res].isBtn == 1) {
          this.pjlsList[res].isBtn = 0;
          e.target.className = "per-btn";
        }
        for (let i in this.pjlsList) {
          if (this.pjlsList[i].isBtn == 1) {
            strList = strList.concat(this.pjlsList[i].name);
            idList = idList.concat(this.pjlsList[i].id);
          }
        }
        this.reset = strList.toString();
        this.resetId = idList.toString();
        this.xzjsList = idList;
      },
      async resetCancel() {
        if(this.resetId  != null){
            var num = this.xzjsList.length
            if(num > this.zdxzls ){
              this.$toast.fail("最多只能选择"+this.zdxzls+"位老师！");
              return null;
            }
            const pjParam = {
              xnxq01id:this.$route.query.xnxq01id,
              pj0502id:this.$route.query.pj0502id,
              sklsids: this.resetId,
              type: 'save'
            }
            const res = await Api.xspjJsmydpj(pjParam)
            if(res.code == '1'){
              this.$toast.success(res.Msg);
              this.sfxzmydpj = '0'
            }else{
              this.$toast.fail(res.Msg);
            }
            this.jsmydshow = false;
        }else{
          this.$toast.fail("请选择你最喜欢的老师!");
          return null;
        }
      },
      close(){
        this.jsmydshow = false;
      },
      async open(){
          const pjParam = {
            xnxq01id:this.$route.query.xnxq01id,
            pj0502id:this.$route.query.pj0502id
          }
          const res = await Api.xspjJsmydpj(pjParam)
          if(res.code == '200'){
            let zxhlsid = res.zxhlsid;
            let concatList2 = [];
            res.skjslst.forEach((item, index) => {
              concatList2[index] = {
                name: item.xm,
                id: item.jg0101id,
                isBtn: zxhlsid.includes(item.jg0101id) ? 1 : 0
              };
            });
            this.pjlsList = concatList2
            console.log(this.pjlsList)
            this.zdxzls = res.zdxzls
            this.jsmydshow = true;
          }
      },
      async dosubmit(){
        if(this.zpjs != '0'){
          this.$toast.fail('评教没有全部评教完，不允许提交！');
          return null;
        }
        Dialog.confirm({
          message: "已完成评价"+this.tjs+"条，未完成"+ this.zpjs +"条，是否确认提交！"
        })
        .then(() => {
          if(this.sfxzmydpj == '1'){
            this.$toast.fail('未设置教师满意度,不能提交!');
          }else{
            this.tjSave()
          }
          
        })
        .catch(() => {
          
        });
      },
      async tjSave(){
        const param = {
          pj01id:this.$route.query.pj01id,
          pj0502id:this.$route.query.pj0502id,
          pj02id:this.$route.query.pj02id,
          pj05id:this.$route.query.pj05id
        }
        const res = await Api.xspjYjtjWhhyzy(param);
        if (res.code == "1") {
          this.$toast.success(res.Msg);
          setTimeout(() => {
            this.$store.state.evaOptCheck = []
            this.getEvaluation()
          },1000)
        }else{
          this.$toast.fail(res.Msg);
        }
      }
    },
    created(){
      this.$store.state.evaOptCheck = []
      this.getEvaluation()
    },
  }
</script>

<style lang="less" scoped>
.grey-contain{display: flex;align-items: center;}
.grey-contain h4{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 22px;}
  .grey-contain button{background-color: @attendance-background-color-1;border-radius: 3px;color: @attendance-color-3;height: 45px;width: 70px;}
  .grey-contain .contain-txt1{line-height: 17px;}
  .grey-contain  p{margin-bottom: 2px;}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .history{border-radius: 3px;background-color: @attendance-background-color-13;color: @attendance-color-3;height: 45px;width: 70px;display: flex;flex-direction: column;align-items: center;justify-content: center;}
  .history h1{font-size: 16px;font-weight: 400;}
  .history p{font-size: 10px;}
  .eva-body{margin-bottom: 90px;overflow: auto;height: calc(~"100vh - 50px - 83px");}
  .body_14507{margin-bottom: 90px;overflow: auto;height: calc(~"100vh - 50px - 260px");}
  .history-btn{position: fixed;bottom: 0;width: 100%;background-color: @attendance-color-3;text-align: center;padding: 0 20px;box-sizing: border-box;}
  .history-btn button{width: 100%;background-color: @attendance-background-color-7;color: @attendance-background-color-1;margin:20px 0;border-radius: 3px;padding: 11px 0}
  .grey-contain_div{display: flex;align-items: center;background-color: white;}

  .apply-pop {
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    max-height: 40%;
    overflow-y: scroll;
  }
  .close-icon {
    background: url(../../../../static/img/close.png) no-repeat center;
  }
  .pop-title {
    display: flex;
    justify-content: space-between;
    padding: 13px;
    position: fixed;
    width: 100%;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    z-index: 9;
  }
  .pop-title i {
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
  }
  .confirm-icon {
    background: url(../../../../static/img/confirm.png) no-repeat center;
  }
  .apply-pop .person {
    padding: 20px 20px 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: 48px;
  }
  .person button {
    border-radius: 3px;
    padding: 5px 15px;
    margin-right: 12px;
    margin-bottom: 15px;
  }
  .apply-pop .person .per-btn {
    background-color: @attendance-background-color-7;
    color: @attendance-background-color-1;
  }
  .person .cur {
    background-color: @attendance-background-color-1;
    color: @attendance-background-color-7;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/teachEvaluate.vue